'use strict';

var util = require('../util/util');

var cache = {};

module.exports = {
    initCache: function () {
        cache.$html = $('html,body');
        cache.$scrollLinks = $('a[data-scroll-to]');
        cache.$collapseCta = $('button[data-toggle="collapse"]');
        cache.$contentContainers = $('.js-content-container');
    },
    scrollUsingGoToParam: function () {
        var goToParamValue = util.getUrlParameter('goTo');

        if (goToParamValue) {
            history.scrollRestoration = 'manual';
            setTimeout(() => {
                $('#' + goToParamValue).trigger('click');
            }, 500);
        }
    },
    scrollFromStartElement: function ($startElement, animation) {
        if (typeof $startElement === 'undefined') {
            return;
        }

        var scrollToId = $startElement.data('scroll-to');
        var $elementToScroll = $('#' + scrollToId);

        if (!$elementToScroll) {
            return;
        }

        cache.$html.animate({
            scrollTop: $elementToScroll.offset().top
        }, animation || 'slow');
    },
    scrollToElementEvents: function () {
        var _this = this;

        cache.$scrollLinks.on('click', function (e) {
            e.preventDefault();

            var $this = $(this);
            var scrollToId = $this.data('scroll-to');
            var $elementToScroll = $('#' + scrollToId);

            if ($elementToScroll.length === 0) {
                return;
            }

            if ($elementToScroll.is('a')) {
                $elementToScroll.focus();
            } else {
                $elementToScroll.closest('.bbw-content-section').find('a').focus();
            }


            // Check if element is collapsed or not
            var $collapsElement = $elementToScroll.closest('.collapse');
            if ($collapsElement.length > 0 && $elementToScroll.closest('.show').length === 0) {
                $elementToScroll.closest('.collapse').collapse('show');

                $collapsElement.off('shown.bs.collapse').on('shown.bs.collapse', function () {
                    var $curentCollapsedElement = $(this);
                    _this.scrollFromStartElement($this);
                    $curentCollapsedElement.off('shown.bs.collapse');
                });
            } else {
                _this.scrollFromStartElement($this);
            }
        });

        window.jRes.addFunc([
            {
                breakpoint: ['xsmall', 'small'],
                enter: function () {
                    cache.$contentContainers.removeClass('show');
                    cache.$collapseCta.addClass('collapsed');
                },
                exit: function () {
                    cache.$contentContainers.addClass('show');
                    cache.$collapseCta.removeClass('collapsed');
                }
            },
            {
                breakpoint: ['medium', 'large', 'extraLarge', 'extraExtraLarge'],
                enter: function () {
                    cache.$contentContainers.addClass('show');
                    cache.$collapseCta.removeClass('collapsed');
                },
                exit: function () {
                    cache.$contentContainers.removeClass('show');
                    cache.$collapseCta.addClass('collapsed');
                }
            }
        ]);
    }
};
